console.log('%cbooklets.js', 'color: yellow');

import * as Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import DBooklets from '@components/organisms/DBooklets.vue';


$(window).on('load', function(e) {
    try {
        const mountEl = document.querySelector('#booklets-app');
        Vue.createApp(DBooklets, {...mountEl.dataset}).use(VueAxios, axios).mount('#booklets-app');
    } catch (e) {
        console.error(e);
    }
})
